import api from "./api";

const vendorService = {
  getDashboard: () => api.get("/vendors/dashboard"),
  getProfile: () => api.get("/vendors/profile"),
  updateProfile: (data) => api.put("/vendors/profile", data),
  submitKYC: (data) => api.post("/vendors/kyc", data),
  getMyMachines: (params) => api.get("/vendors/machines", { params }),
  getMachineForEdit: (id) => api.get(`/machines/vendor/${id}`),
  getMyOrders: (params) => api.get("/vendors/orders", { params }),
  getEarnings: () => api.get("/vendors/earnings"),
  createMachine: (data) => api.post("/machines", data),
  updateMachine: (id, data) => api.put(`/machines/${id}`, data),
  deleteMachine: (id) => api.delete(`/machines/${id}`),
  updateOrderStatus: (orderId, action, data = {}) => {
    return api.patch(`/bookings/${orderId}/${action}`, data);
  },
};

export default vendorService;
